import React from 'react'
import { useForm } from 'react-hook-form'
import './ConfirmationModal.scss'
import CodeInput from '../../CodeInput'
import {
  CONFIRMATION_TYPES,
  CONFIRMATION_TYPES_LABELS,
  DEFAULT_EMAIL,
} from './constants'

export default function ConfirmationModal({
  breakPermalink,
  extraConfirmationData,
  stepId,
  stepType,
  values,
  validateTokenService,
  onConfirm,
  onSendToken,
}) {
  const {
    email,
    phoneNumber,
    firstName,
    lastName,
    type = CONFIRMATION_TYPES.EMAIL,
  } = values || {
    email: DEFAULT_EMAIL,
    firstName: null,
    lastName: null,
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    watch,
  } = useForm()

  const onSubmit = async (data, e) => {
    e.preventDefault()
    e.stopPropagation()
    const code = data.codeInput
    if (!validateTokenService) {
      onConfirm({ values, confirmed: true, token: code })
      return
    }
    const confirmationData = {
      tokenSource: stepType,
      email,
      token: code,
      phoneNumber: type === CONFIRMATION_TYPES.EMAIL ? null : phoneNumber,
      type,
      ...extraConfirmationData,
    }
    const isEmailValid = await validateTokenService(confirmationData)

    isEmailValid
      ? onConfirm({ values, confirmed: true, token: code })
      : setError('codeInput', {
          type: 'manual',
          message: 'Invalid code',
        })
  }

  const handleCodeInputChange = input => {
    codeInput.onChange({
      target: {
        value: input,
        name: 'codeInput',
      },
    })
  }

  const handleOnClick = async e => {
    e.preventDefault()
    e.stopPropagation()
    try {
      await onSendToken({
        email,
        firstName,
        lastName,
        stepId,
        breakPermalink,
        tokenSource: stepType,
        type: values.type,
        phoneNumber,
      })
    } catch {
      setError('codeInput', {
        type: 'manual',
        message: 'Please enter a valid email address',
      })
    }
  }

  const codeInput = register('codeInput', { required: true })
  const codeInputWatcher = watch('codeInput')

  return (
    <div
      style={{
        backgroundColor: 'white',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <form
        id="confirmation-modal-form"
        className="email-confirmation-container"
      >
        <div>
          <h2>Confirm your {CONFIRMATION_TYPES_LABELS[type]}</h2>
          <p className="email-text">
            We've sent a code to your {CONFIRMATION_TYPES_LABELS[type]}:&nbsp;
            <span className="email-link-resender">
              {type === CONFIRMATION_TYPES.EMAIL ? email : phoneNumber}
            </span>
            . Please enter it below to confirm your{' '}
            {CONFIRMATION_TYPES_LABELS[type]}.
          </p>
        </div>
        <div className="email-code-container">
          <label htmlFor="codeInput">Enter the code</label>
          <CodeInput
            allowedCharacters="numeric"
            ref={codeInput.ref}
            onChange={handleCodeInputChange}
          />
          {errors.codeInput && (
            <span className="error-message">{errors.codeInput?.message}</span>
          )}
          <button className="email-link-resender" onClick={handleOnClick}>
            <span className="email-link-resender">Resend code</span>
          </button>
        </div>
        <button
          disabled={codeInputWatcher?.length !== 6}
          className="btn"
          type="button"
          form="confirmation-modal-form"
          onClick={handleSubmit(onSubmit)}
        >
          Confirm code
        </button>
      </form>
    </div>
  )
}
